const parseArrayQueryParam = (array) => {
  return array && array.length ? array.join() : void 0;
};
export {
  parseArrayQueryParam
};
